import { put } from 'redux-saga/effects';
import { restreamingRequested } from 'features/restreamer/restreamerSlice';

export function* onRestreamingRequestedSaga() {
  yield put(restreamingRequested());
}
